<template>
  <component :is="component" v-if="component"/>
</template>

<script>
export default {
  name: "PaginationLink",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
    paginationLayout: {},
  },
  data() {
    return{
      component: null,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
    this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/award/pagination/PaginationDefaultLayout')
        })
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
    loader() {
      if (!this.paginationLayout) {
        return null
      }
      return () => import(`@/template/award/pagination/${this.paginationLayout}`)
    },
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>